import { ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatStepper } from '@angular/material/stepper';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { TranslateService } from '@ngx-translate/core';
import { forkJoin, Observable, of } from 'rxjs';
import { first, switchMap } from 'rxjs/operators';
import {
  EmailService,
  ISendOperativeEmail,
  SendOperativeEmailEnum,
} from 'src/app/core/http/apiNotify/email.service';
import {
  INotificationSMS,
  NotificationService,
} from 'src/app/core/http/apiNotify/notificaciones.service';
import { ICreatePersonaBody, ICreatePersonaPagoBody, PersonaService } from 'src/app/core/http/apiPersona/persona.service';
import { PolizasService } from 'src/app/core/http/apiPolicy/polizas.service';
import { ContratarService, ISaleBody } from 'src/app/core/http/apiPricing/contratar.service';
import { CotizacionService, IUpdateCotizacionBody } from 'src/app/core/http/apiPricing/cotizacion.service';
import { ObjetosService } from 'src/app/core/http/apiProducto/objetos.service';
import { IClientContract } from 'src/app/core/interfaces/shared/bundle/IClientContract';
import { IInvoiceContract } from 'src/app/core/interfaces/shared/bundle/IInvoiceContract';
import { IProductContract } from 'src/app/core/interfaces/shared/bundle/IProductContract';
import { IPolicyOrQuotation } from 'src/app/core/interfaces/shared/components/IPolicyOrQuotation';
import IHttpResponse from 'src/app/core/interfaces/shared/IHttpResponse';
import { SpinnerService } from 'src/app/core/services/spinner/spinner.service';
import { selectContract } from 'src/app/state/contracts/contracts.selectors';
import { selectSelectedObject } from 'src/app/state/objects/objects.selectors';
import { selectSelectedPaymentFractions } from 'src/app/state/paymentFractions/paymentFractions.selectors';
import { setQuote } from 'src/app/state/quotation/quotation.actions';
import { IQuotation } from 'src/app/state/quotation/quotation.models';
import { selectQuotation } from 'src/app/state/quotation/quotation.selectors';
import { selectPartner } from 'src/app/state/user/user.selectors';
import { notifyType } from '../../cards/client-notification-card/client-notification-card.component';
import { GlobalDialogComponent } from '../../globaldialog/globaldialog.component';

export interface IStepperData {
  productData?: IProductContract;
  productReadOnly?: boolean;
  clientData?: IClientContract;
  clientReadOnly?: boolean;
  notificationCardReadOnly?: boolean;
  invoiceData?: IInvoiceContract;
  invoiceReadOnly?: boolean;
  finishButton?: boolean;
  idCotizacion?: number;
  sendNotification?: boolean;
  showBannerNotification?: boolean;
  showBannerInvoice?: boolean;
}

@Component({
  selector: 'app-vertical-stepper',
  templateUrl: './vertical-stepper.component.html',
  styleUrls: ['./vertical-stepper.component.scss'],
})
export class VerticalStepperComponent implements OnInit {
  @Input() StepperData: IStepperData = {}
  @Input() stepperIsLinear: boolean = true

  // Data forms //
  productData: IProductContract;
  clientData: IClientContract;
  invoiceData: IInvoiceContract;

  finishInsuranceBtn: boolean;

  notifyMethodData: number;

  idCotizacion: number;

  setTimeOut: ReturnType<typeof setTimeout>;

  selectQuotation$: Observable<IQuotation>;

  action$: Observable<IHttpResponse<any>>;

  keyTranslate: string = 'clientContracts.verticalStepper';
  finishPopupKeyTranslate: string = 'clientContracts.forms.payContractForm';
  finishButton: boolean;

  cotizacion_autorizada: boolean = false;

  isCompleted_step1: boolean = false;
  isCompleted_step2: boolean = false;

  resendButton: boolean = false
  productFormDisabled: boolean = false
  stepper: MatStepper;

  constructor(
    private translateService: TranslateService,
    private store: Store,
    private emailService: EmailService,
    private notificationService: NotificationService,
    private dialog: MatDialog,
    private cotizacionService: CotizacionService,
    private spinnerService: SpinnerService,
    private contratarService: ContratarService,
    private personaService: PersonaService,
    private router: Router,
    private cdRef: ChangeDetectorRef,
    private objetosService: ObjetosService,
    private polizasService: PolizasService,
  ) { }

  ngOnInit(): void {
    this.idCotizacion = this.getQuotationId();
    this.productData = this.StepperData.productData;
    this.clientData = this.StepperData.clientData;
    this.invoiceData = this.StepperData.invoiceData;
    this.finishButton = this.StepperData.finishButton;
  }

  applyDisabledStyle(stepperDataValue:boolean, productFormDisabled?:boolean):boolean{
    if(stepperDataValue || productFormDisabled){
      return true
    }else{
      return false
    }
  }

  addProductFormData(event) {

    this.productData = event;
    this.invoiceData = null;

    if (!event) return;

    const quotation$ = this.store.select(selectQuotation).pipe(first());
    const selected_object$ = this.store.select(selectSelectedObject).pipe(first());

    forkJoin([quotation$, selected_object$])
      .subscribe(([quotation, selected_object]) => {

        const body: IUpdateCotizacionBody = {
          marca: this.productData.marca,
          modelo: this.productData.modelo,
          numeroSerie: this.productData.numSerie,
        }

        this.cotizacionService.updateCotizactionRiesgo(quotation.idCotizacion, selected_object.id, body).subscribe();
      })

  }
  
  resendNotificationButton(stepper: MatStepper){
    this.resendButton = true
    stepper.next()
  }

  isCompleted(step, event){

    if(step === 'isCompleted_step1'){
      this.isCompleted_step1 = event
    }else if(step === 'isCompleted_step2'){
      this.isCompleted_step2 = event
    }else{
      return 
    }
  }

  addClientFormData(event: IClientContract) {

    this.clientData = event;
    this.invoiceData = null;
    this.StepperData.sendNotification = false;

    if (!event.idCliente) this.StepperData.sendNotification = false

    if (!event) return;

    this.StepperData.sendNotification = true;

    if (!event.idPersona) {
      this.createPersona();
    } else {
        // Actualización de datos de cliente
      this.updateAddressPersonData(event)
      this.updatePersonData(event);
      this.updatePhonePersonData(event.idPersona, event.telefono)

      const select_partner$ = this.store.select(selectPartner).pipe(first());
      const quotation$ = this.store.select(selectQuotation).pipe(first());

      if(!this.clientData.idCliente){
        forkJoin([select_partner$, quotation$]).subscribe(([partner, quotation]) => {
          const create_personaPago_body: ICreatePersonaPagoBody = {
            entidad: partner.idEntidadDependiente,
            gestionCliente: 1,
            idPersona: event.idPersona
          };
          
          this.personaService.createCliente(create_personaPago_body).pipe(first())
          .subscribe(resp => {
            this.clientData.idCliente = resp.data.cliente.idCliente;
            this.cotizacionService.updateCotizactionCliente(quotation.idCotizacion, this.clientData.idCliente).subscribe()
          })
        })
      } else {
        this.store.select(selectQuotation).pipe(first()).subscribe(quotation => {
          this.cotizacionService.updateCotizactionCliente(quotation.idCotizacion, this.clientData.idCliente).subscribe()
        })
      }
    }
  }

  updatePersonData(eventData){
    const clientData = {
      id: eventData.idPersona,
      nombre: eventData?.nombre,
      Apellido1: eventData?.apellidos,
      // NumDocumento: eventData?.dni,
    }

    this.personaService.setPersona(clientData).subscribe({
      next: () => {},
      error: () => console.log("Error al actualizar la persona.")
    })
  }

  updatePhonePersonData(idPerson, phoneNumber){
    this.personaService.setTelefono(idPerson, phoneNumber).subscribe({
      next: () => {},
      error: () => console.log("Error al actualizar el teléfono.")
    })
  }

  updateAddressPersonData(event){
    const data = {
      nombreVia: event.direccion,
      codigoPostal: event.codigoPostal
    }
    
    this.personaService.setDomicilioPersona(event.idPersona, data).subscribe(
      {
      next: () => {},
      error: () => console.log("Error al actualizar el domicilio.")
    })
  }

  addInvoiceFormData(event) {

    // console.log("Invoice data changed and is valid", event);

    this.invoiceData = event;

    if (!event) return;

    const quotation$ = this.store.select(selectQuotation).pipe(first());
    const selected_object$ = this.store.select(selectSelectedObject).pipe(first());

    forkJoin([quotation$, selected_object$])
      .subscribe(([quotation, selected_object]) => {

        const body: IUpdateCotizacionBody = {
          marca: this.productData.marca,
          modelo: this.productData.modelo,
          numeroSerie: this.productData.numSerie,
          numeroFactura: this.invoiceData.factura
        };

        this.cotizacion_autorizada = quotation.autorizada;

        this.cotizacionService.updateCotizactionRiesgo(quotation.idCotizacion, selected_object.id, body).subscribe(resp => {
          
          this.cotizacionService.getCotizationList({ idCotizacion: quotation.idCotizacion })
            .pipe(first())
            .subscribe(resp => {
              const quote = resp.data[0];
              this.store.dispatch(setQuote({ quote: resp.data[0] }));
              this.cotizacion_autorizada = quote.autorizada;
              this.cdRef.detectChanges();
            })
        });
      })

  }

  getQuotationId(): number {
    let idCotizacion;
    this.store
      .select(selectQuotation)
      .pipe(first())
      .subscribe((res) => {
        idCotizacion = !res ? this.StepperData.idCotizacion : res.idCotizacion
      })
    return idCotizacion
  }

  /**
   * Receive from the child component the send method and notify with this
   * @param event
   */
  notifyTypeEventHandler(event: notifyType, stepper: MatStepper): void {
    this.notifyMethodData = event;
    this.stepper = stepper;
    this.spinnerService.show();

    const selectQuotation$ = this.store.select(selectQuotation).pipe(first());
    const selectContractQuotation$ = this.store.select(selectContract).pipe(first());

    forkJoin([
      selectQuotation$,
      selectContractQuotation$
    ]).subscribe(([quotation, contract]) => {

      const quote: IPolicyOrQuotation = quotation || contract.clientData.quotation.data

      let confirmarCotizacion$ = this.cotizacionService.confirmarCotizacion(quote.idCotizacion);

      if (quote.estadoInterno === 'Proyecto') {
        confirmarCotizacion$ = of(true)
      }

      confirmarCotizacion$.subscribe(_ => {

        if (!!quotation && quotation.estadoInterno === 'Borrador') {
          const new_quote = { ...quotation, estadoInterno: 'Proyecto' }

          this.store.dispatch(setQuote({ quote: new_quote }))
        }


        if (this.notifyMethodData === notifyType.Email) {

          this.sendQuotationEmail();
        } else if (this.notifyMethodData === notifyType.SMS) {
          this.sendQuotationSMS(this.clientData.telefono);

        } else {
          this.spinnerService.hide();
          throw new Error('Notify type not implemented.');
        }
      })
    })
  }

  sendQuotationEmail(): void {

    this.store.select(selectQuotation).pipe(first()).subscribe(quotation => {

      this.cotizacionService.getCotizationList({ idCotizacion: quotation.idCotizacion })
        .pipe(
          first(),
          switchMap(resp => of(resp.data[0]))
        )
        .subscribe(vCotizacion => {

          const root = location.origin;;
          const url_landing = `${root}/landing/${vCotizacion.uidCotizacion}`;

          const sendEmailBody: ISendOperativeEmail = {
            email: this.clientData.email,
            operative: "MailByProduct",
            template: "CotiEmail",
            parameters: [
              { name: 'idProduct', value: quotation.idProducto.toString() },
              { name: 'objeto', value: url_landing },
              { name: 'nombre', value: this.clientData.nombre || "" }
            ]
          };

          
          this.emailService
            .sendEmail(sendEmailBody)
            .pipe(first())
            .subscribe((seended) => {
              console.log(seended);
              this.sendDialogTimer();
              if (seended.succeeded) {
                console.log(seended);
              } else {
                console.log('Error al enviar el email');
              }
            });
        })
    })
  }

//ENVIO DE SMS
  // Función principal que envía una cotización por SMS al número de teléfono dado.
  sendQuotationSMS(phoneNumber) {
    this.store.select(selectQuotation).pipe(first()).subscribe(quotation => {
      this.fetchQuotationDetails(quotation.idCotizacion, phoneNumber);
    });
  }

  // Función para obtener los detalles de la cotización y enviar el SMS.
  fetchQuotationDetails(quotationId, phoneNumber) {
    this.cotizacionService.getCotizationList({ idCotizacion: quotationId })
      .pipe(
        first(),
        switchMap(resp => of(resp.data[0]))
      )
      .subscribe(vCotizacion => {
        this.sendQuotationSMSToNumber(vCotizacion, phoneNumber);
      });
  }

  // Función para enviar el contenido de cotización como SMS al número de teléfono.
  sendQuotationSMSToNumber(vCotizacion, phoneNumber) {
    const root = location.origin;
    const url_landing = `${root}/landing/${vCotizacion.uidCotizacion}`;

    this.objetosService.GetCoverageInfoScreenByIdProduct('SMS', vCotizacion.idProducto).subscribe((res) => {
      const smsContent = res.data[0].descPantallaSeccion.replace('[URL]', url_landing);

      const smsData: INotificationSMS = {
        tlfNumber: phoneNumber,
        content: smsContent,
      };

      this.sendSMSThroughService(smsData);
    });
  }

  // Función para enviar el SMS utilizando el servicio de notificaciones.
  sendSMSThroughService(smsData) {
    this.action$ = this.notificationService.sendNotificationSMS(smsData).pipe(first());

    this.action$.subscribe((seended) => {
      if (seended) {
        console.log('La respuesta del sms: ', seended);
        this.sendDialogTimer();
      } else {
        console.log('Error al enviar el sms');
        this.spinnerService.hide();
      }
    });
  }
// FIN ENVIO SMS


  sendDialogTimer() {
    let keyTranslate = 'client-notification-card.dialog.sendDialogTimer';

    this.selectQuotation$ = this.store.select(selectQuotation).pipe(first());

    const dialogRef = this.dialog.open(GlobalDialogComponent, {
      disableClose: true,
      panelClass: 'countDown-panel',
      data: {
        icon: 'clockCountdown',
        timer: true,
        subtitle: this.translateService.instant(`${keyTranslate}.subtitle`),
        button: {
          type: 'timer',
          text: this.translateService.instant(`${keyTranslate}.textButton`),
        },
        closeIcon: true

      },
    });

    this.spinnerService.hide();

    this.recursiveTimeOut(this.idCotizacion, dialogRef);

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        switch (result.action) {
          case 'resend_notify':
            this.notifyTypeEventHandler(this.notifyMethodData, this.stepper);
            break;
          default:
            throw new Error('Not implemented popup result action');
        }
      }

      clearTimeout(this.setTimeOut);
    });
  }

  recursiveTimeOut(
    idCotizacion: number,
    dialog: MatDialogRef<GlobalDialogComponent, any>
  ) {
    this.setTimeOut = setTimeout(() => {
      this.cotizacionService
        .getCotizacion(idCotizacion)
        .pipe(first())
        .subscribe((resp) => {

          if (!resp.data.autorizada) {
            this.recursiveTimeOut(idCotizacion, dialog);
          } else {
            this.sendDialogConfirm();
            this.productFormDisabled = true;
          }

        });
    }, 5 * 1000);
  }

  sendDialogConfirm() {
    let keyTranslate = 'client-notification-card.dialog.sendDialogConfirm';

    this.dialog.closeAll();

    const dialogRef = this.dialog.open(GlobalDialogComponent, {
      disableClose: true,
      panelClass: 'countDown-panel',
      data: {
        icon: 'userCheck',
        title: this.translateService.instant(`${keyTranslate}.title`),
        button: {
          type: 'close',
          text: this.translateService.instant(`${keyTranslate}.textButton`),
        },
        closeIcon: true

      },
    });

    dialogRef.afterClosed().subscribe(() => {
      this.spinnerService.hide();
      this.stepper.next();
    });
  }

  contratar() {

    this.spinnerService.show();

    const select_paymentFractionSelected$ = this.store.select(selectSelectedPaymentFractions).pipe(first());
    const select_quotation$ = this.store.select(selectQuotation).pipe(first());
    const select_partner$ = this.store.select(selectPartner).pipe(first());
    const get_duracionPolizas$ = this.contratarService.getDuracionPolizas().pipe(first());
    
    // Actualizamos el idEntidad en el proceso base, en caso de que sea necesario
    forkJoin([select_quotation$, select_partner$]).subscribe(([quotation, partner]) => {

      if(quotation.idEntidad !== partner.idEntidad ){
        this.cotizacionService.updateCotizacionIdEntidad(quotation.idCotizacion, partner.idEntidad).subscribe( _ => {
          this.store.dispatch(updateQuotationIdEntidad({ idEntidad: partner.idEntidad}));
        });
      }
    });

    // creamos personaPago a partir de la persona y el partner y selecionamos la fraccionPago y la cotizacion del store
    forkJoin([get_duracionPolizas$, select_paymentFractionSelected$, select_quotation$])
      .subscribe(([duracionPolizas_resp, paymentFraction, quotation]) => {


        this.personaService.getPersonaPagos(this.clientData.idPersona).pipe(first())
          .subscribe(personaPagos_resp => {

            const duracionPoliza_renovable = duracionPolizas_resp.data.find(x => x.alias === "RE");
            const personaPago_defecto = personaPagos_resp.data.find(x => x.defecto) || personaPagos_resp.data[0];
            const contratar_body: ISaleBody = {
              body: {
                duracionPoliza: duracionPoliza_renovable.id
              },
              process: {
                tomadorPago: personaPago_defecto.idPersonaPago,
                idCliente: this.clientData.idCliente,
                idPersona: this.clientData.idPersona
              }
            };

            // contratamos con todos los datos obtenidos en las llamadas
            this.contratarService.contratar(quotation.idCotizacion, paymentFraction.id, contratar_body).pipe(first())
              .subscribe(resp => {

                if (resp.succeeded) {
                  // LLAMADA A NAMIRIAL PARA ENVIAR LA FIRMA ELECTRONICA POR EMAIL
                  this.polizasService.sendEsign(resp.data.idMovimiento).subscribe(res=> {
                    this.spinnerService.hide();
                    this.finishDialogConfirm();
                  }, _ => this.spinnerService.hide());
                }

              }, _ => this.spinnerService.hide());

          }, _ => this.spinnerService.hide());

      }, _ => this.spinnerService.hide());
  }

  createPersona() {

    const create_persona_body: ICreatePersonaBody = {
      accesoAplicacion: false,
      nombre: this.clientData.nombre,
      apellido1: this.clientData.apellidos,
      credencialesEnviadas: true,
      email: this.clientData.email,
      idioma: 1,
      numDocumento: this.clientData.dni,
    };

    const quotation$ = this.store.select(selectQuotation).pipe(first());
    const create_persona$ = this.personaService.createPersona(create_persona_body).pipe(first());
    const select_partner$ = this.store.select(selectPartner).pipe(first());

    forkJoin([create_persona$, select_partner$, quotation$]).subscribe(([persona_resp, partner, quotation]) => {

      this.clientData.idPersona = persona_resp.data.persona.idPersona;

      const create_personaPago_body: ICreatePersonaPagoBody = {
        entidad: partner.idEntidadDependiente,
        gestionCliente: 1,
        idPersona: this.clientData.idPersona
      };

      this.personaService.createCliente(create_personaPago_body).pipe(first())
        .subscribe(resp => {
          this.clientData.idCliente = resp.data.cliente.idCliente;

          const domicilio_body = {
            calle: {
              oldname: this.clientData.direccion,
              name: this.clientData.direccion
            },
            cp: this.clientData.codigoPostal
          }
          
          this.personaService.setDomicilioPersona(this.clientData.idPersona, domicilio_body).subscribe(resp => {
          })
          
          this.personaService.setTelefono(this.clientData.idPersona, this.clientData.telefono).subscribe(resp => {
          })
          
          this.cotizacionService.updateCotizactionCliente(quotation.idCotizacion, this.clientData.idCliente).subscribe(resp => {
          })
        });
    });
  }

  finishDialogConfirm() {

    const title = this.translateService.instant(this.finishPopupKeyTranslate + '.finishDialog.title')
    const subtitle = this.translateService.instant(this.finishPopupKeyTranslate + '.finishDialog.subtitle')
    const buttonText = this.translateService.instant(this.finishPopupKeyTranslate + '.finishDialog.buttonText')

    this.dialog.closeAll();
    const dialogRef = this.dialog.open(GlobalDialogComponent, {
      disableClose: true,
      panelClass: 'finishDialog-panel',
      data: {
        icon: 'checkCircle',
        title: title,
        subtitle: subtitle,
        button: {
          type: 'close',
          text: buttonText
        },
        closeIcon: true

      },
    });
    dialogRef.afterClosed().pipe(first()).subscribe(_ => {
      this.router.navigate(['/calculator'])
    })
  }
}
function updateQuotationIdEntidad(arg0: { idEntidad: number; }): any {
  throw new Error('Function not implemented.');
}

